var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCup = function SvgCup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4444",
    fillRule: "evenodd",
    d: "M1.5 1.5a.5.5 0 1 0 0 1H2v7a2 2 0 0 0 2 2h.807l-.782 2.342a.5.5 0 1 0 .95.316l.219-.658h5.612l.22.658a.5.5 0 0 0 .948-.316l-.78-2.342H12a2 2 0 0 0 2-2v-7h.5a.5.5 0 0 0 0-1zm4.36 10h4.28l.333 1H5.527zm5.39-5.997a.5.5 0 1 0-.5-.866 8.5 8.5 0 0 0-2.372 2.034L7.353 5.647a.5.5 0 0 0-.706 0l-2 2a.5.5 0 1 0 .706.706L7 6.707l1.078 1.078a.5.5 0 0 0 .764-.068 7.54 7.54 0 0 1 2.408-2.214",
    clipRule: "evenodd"
  })));
};
export default SvgCup;